





































import { Component, Prop } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';

import { MapStore } from '@/store/map';
import { Checkbox } from '@/components/forms';
import { WidgetGeneric } from '@/components/widgets';
import { Radio } from '@/components/forms';
import { WidgetConfig, MarkerTemplateParams } from '@/models/widget-config.model';

@Component({
  components: { Checkbox, Radio }
})
export default class WidgetImmovable extends WidgetGeneric {
  @Prop({ required: true, default: [] }) readonly checkboxes!: Record<string, any>[];
  @Prop({ required: true }) readonly closeOpenSubCategories!: () => void;

  created(): void {
    this._mapStore = getModule(MapStore, this.$store);
    this._points = new Map();
    this._widgetType = 'IMMOVABLE';
    this._config = this._createConfig();
    this._mapStore.map.on('click', this._removePopups);
  }

  beforeDestroy(): void {
    this.checkboxes.forEach((checkbox: any) => {
      checkbox.selected = false;
      if (checkbox.open) checkbox.open = false;
      if (checkbox.subCat) {
        checkbox.subCat.forEach((el: any) => {
          el.selected = false;
        });
      }
    });
    this._beforeDestroy();
    this._mapStore.map.off('click', this._removePopups);
  }

  change({ type, value }: { type: string; value: boolean }) {
    if (this._points.has(type)) {
      // typescript issue https://github.com/microsoft/TypeScript/issues/9619
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this._points.get(type)!.visibility = value;
    }
    if (type === 'coworkings' && !value) {
      this._mapStore.setCoworkingsPopup(null);
    }
    if (this._points.has(type)) this._addToMap();
    else this._getPoints(type).then(() => this._addToMap());
  }

  private _createConfig(): WidgetConfig {
    const config: any = {};
    this.checkboxes.forEach((checkbox: Record<string, any>) => {
      config[checkbox.type] = { marker: WidgetImmovable._markerTemplate, tableName: checkbox.type };
      if (checkbox.subCat) {
        config[checkbox.type].tableNames = checkbox.subCat.map((el: any) => {
          config[el.type] = { marker: WidgetImmovable._markerTemplate };
          return el.type;
        });
      }
    });
    return config;
  }

  private static _markerTemplate({ type }: MarkerTemplateParams): HTMLDivElement {
    const markerElement = document.createElement('div');
    // markerElement.className = `marker-immovable marker-immovable--${type.toLowerCase()}`;
    markerElement.classList.add('marker-immovable', `marker-immovable--${type.toLowerCase()}`, 'background-color');

    return markerElement;
  }

  private static _markerTemplateImage(data: MarkerTemplateParams): HTMLDivElement {
    if (data.image) {
      const markerElement = document.createElement('div');
      // markerElement.className = `marker-immovable marker-immovable--grand_projects`;
      markerElement.classList.add('marker-immovable', 'marker-immovable--grand_projects', 'background-color');
      markerElement.innerHTML = `<img src="${data.image}" />`;
      return markerElement;
    } else {
      const markerElement = document.createElement('div');
      // markerElement.className = `marker-immovable marker-immovable--${data.type.toLowerCase()}`;
      markerElement.classList.add(
        'marker-immovable',
        `marker-immovable--${data.type.toLowerCase()}`,
        'background-color'
      );

      return markerElement;
    }
  }
}
